import { ApiClient } from "../../api/ApiClient";
import "../clientConfig/index.scss";
import { Toast, Modal, Col as RowCol } from "@douyinfe/semi-ui";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { IconCloudUploadStroked } from "@douyinfe/semi-icons";

import { useState, useContext, useEffect } from "react";
import { Col, ColType, Crud, CrudAction, CrudApi } from "../../comp/crud";
import { SiteInfoContext } from "../context/SiteInfoContext";

export default function BankTrustEnterprise() {
  const [importing, setImporting] = useState(false);
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const siteInfo = useContext(SiteInfoContext);
  let apiClient = ApiClient.getDefault();
  let rootPri = false;
  const role = localStorage.getItem("role");
  if ( role == "root" || role == "op_manager" ) {
    rootPri = true;
  } else {
    rootPri = false;
  }

  let cols: Col[] = [
    {
      name: "城市",
      key: "city",
      showInFilter: rootPri,
      optional: true,
      getOptions: () => apiClient.getBankEntCityAsOpts(),
      type: ColType.SELECT,
    },

    {
      name: "企业",
      key: "enterpriseName",
      showInFilter: true,
      type: ColType.STRING,
    },
    {
      name: "银行",
      showInFilter: rootPri,
      key: "bankName",
      type: ColType.STRING,
    },
    {
      name: "备注",
      showInFilter: false,
      optional: true,
      key: "remark",
      type: ColType.STRING,
    },

    {
      name: "更新时间",
      key: "updatedAt",
      type: ColType.DATETIME,
      hideInEdit: true,
      hideInCreate: true,
    },
  ];

  const actions: CrudAction[] = [];

  const handleImportClick = () => {
    let input = document.createElement("input");
    input.type = "file";
    input.accept = ".xlsx";
    input.onchange = async () => {
      let file = input.files![0];
      if (!file) {
        return;
      }
      setImporting(true);
      try {
        const resp = await apiClient.request<number>(
          "/bankTrustEnterprise/import",
          "POST",
          undefined,
          undefined,
          file
        );
        Toast.info(`导入企业成功`);
        setImporting(false);

        crudApi?.refresh();
      } catch (e) {
        setImporting(false);
      }
    };
    input.click();
  };

  const imporAction: CrudAction = {
    name: "导入企业",
    action: handleImportClick,
    loading: importing,
    icon: <IconCloudUploadStroked />,
  };

  const handleTemplateClick = () => {
    window.open(siteInfo?.siteUrl + "/file/importEnt.xlsx", "_blank");
  };
  const importTemplateAction: CrudAction = {
    name: "下载导入模板",
    action: handleTemplateClick,
    loading: importing,
  };

  if (rootPri) {
    actions.push(importTemplateAction);
    actions.push(imporAction);
  } 

  const deleteRow = (id: number) => {
    Modal.confirm({
      title: "是否确认删除？",
      content: "",
      onOk: async () => {
        try {
          await apiClient.request<boolean>(
            "/bankTrustEnterprise/" + id,
            "DELETE"
          );
          Toast.info("删除成功");

          crudApi?.refresh();
        } catch (e) {}
      },
    });
  };

  return (
    <Crud
      getCrudApi={(crudApi) => {
        setCrudApi(crudApi);
      }}
      actions={actions}
      canUpdate={rootPri}
      canCreate={rootPri}
      name="易贷通企业"
      entityKey="bankTrustEnterprise"
      getRowActions={(a) => {
        if (rootPri) {
          return [
            {
              name: "删除",
              action: () => {
                deleteRow(a.id);
              },
            },
          ];
        } else {
          return [];
        }
      }}
      pageSize={50}
      cols={cols}
    />
  );
}
